import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'wr-corporate-group-delete-dialog',
  templateUrl: './corporate-group-delete-dialog.component.html',
  styleUrls: ['./corporate-group-delete-dialog.component.scss'],
})
export class CorporateGroupDeleteDialogComponent {
  @Input() groupName = '';
  @Input() memberCount = 0;

  get blocked(): boolean {
    return this.memberCount > 0;
  }
}
